
export const LEVEL_OF_SATISFACTION_3 = [
  {
    value: '1/3',
    iconName: 'survey-face-bad'
  },
  {
    value: '2/3',
    iconName: 'survey-face-neutral'
  },
  {
    value: '3/3',
    iconName: 'survey-face-super-good'
  }
] as const;

export const LEVEL_OF_SATISFACTION_5 = [
  {
    value: '1/5',
    iconName: 'survey-face-bad'
  },
  {
    value: '2/5',
    iconName: 'survey-face-poor'
  },
  {
    value: '3/5',
    iconName: 'survey-face-neutral'
  },
  {
    value: '4/5',
    iconName: 'survey-face-good'
  },
  {
    value: '5/5',
    iconName: 'survey-face-super-good'
  }
] as const;